
import {Component, Vue} from 'vue-property-decorator';
import {
  dispatchCreateFormCategory,
  dispatchGetFormCategory, dispatchUpdateFormCategory,
} from '@/store/admin/actions';
import { readFormCategory} from '@/store/admin/getters';
import {rules} from '@/utils';
import {dispatchGetUserProfile} from '@/store/main/actions';
import {IGroup} from "@/interfaces/group";
import {IFormCategory} from "@/interfaces/form";

@Component({})
export default class CRUDFormCategory extends Vue {
  private formCategory: IFormCategory = {} as IFormCategory;
  private rules: any = rules;

  private valid: boolean = false;
  private title: string = `${this.$t('crud.create')} ${this.$t('form_category')}`;
  private formCategoryId: number = -1;


  public async mounted() {
    this.formCategoryId = this.$router.currentRoute.params.id as unknown as number;

    if (this.formCategoryId > 0) {
      await dispatchGetFormCategory(this.$store, this.formCategoryId)
      this.title = `${this.$t('crud.update')} ${this.$t('group')}`;
      this.formCategory = readFormCategory(this.$store)(+this.formCategoryId) as IFormCategory;
    } else {
      this.formCategory = {} as IFormCategory;
      this.formCategoryId = 0;
    }

  }

  public beforeRouteLeave(to, from, next) {
    this.formCategory = {} as IFormCategory;
    this.title = `${this.$t('crud.create')} ${this.$t('form_category')}`;
    this.formCategoryId = 0;
    next();
  }

  private cancel() {
    this.$router.back();
  }

  private reset() {
    this.formCategory = {} as IFormCategory;
  }

  private async submit() {
    const form: any = this.$refs.form_form_category;
    if (await form.validate()) {
      if (this.formCategoryId > 0) {
        if (await dispatchUpdateFormCategory(this.$store, this.formCategory)) {
          await this.$router.push({name: 'main-admin-forms-form-category-list'});
        }
      } else {
        if (await dispatchCreateFormCategory(this.$store, this.formCategory)) {
          await this.$router.push({name: 'main-admin-forms-form-category-list'});
        }
      }
    }
  }


}
